/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const exportEntries = {
  exportToCsv: 'Export to CSV',
  exportMessage:
    'The CSV file will be automatically downloaded to your device; if not, check your browser settings',
  columnNombres: {
    code: 'Code',
    quantity: 'Quantity',
    name: 'Name',
    price: 'Price',
  },
  exportProductToCsv: 'Export product to CSV',
};

export const importEntries = {
  importProducts: 'Import Cart',
};

export const importEntriesDialog = {
  importProducts: 'Import Cart',
  fileUploaded: 'Entries Imported Sucessfully',
  importProductsRulesTitle: 'Import products to your saved carts from a .xlsx file',
  importProductsFirstRule: 'Quantity, Package Type, Weight, Group, Quality, Dimensions, Certificates',
  importProductsSecondRule: 'Maximum file size: 976 KB',
  importProductsSubtitle: 'The imported file will be used to create a new cart that you can view in the My Account / Saved Carts section.',
  importProductFileDetails:
    'Select the file to upload. First, you must download the file to complete: ',
  importProductClickHere: 'Click here',
  importProductFileDetailsFinal: 'to download file',
  importProductsNewSavedCartSubtitle:
    'Add products by importing a .CSV file and creating a new saved cart.',
  selectFile: 'Select file',
  savedCartNombre: 'Saved cart number',
  savedCartDescription: 'Saved cart description',
  opcional: 'optional',
  charactersLeft: 'Characters left: {{count}}',
  cancel: 'Cancel',
  upload: 'Upload',
  close: 'Close',
  summary: {
    info: 'Do not close or refresh this window while products are being imported.',
    loadedToCart: 'Products have been loaded into the cart {{ cartName }}',
    loaded: 'Products have been loaded',
    loading: 'Products are being processed... ({{ count }}/{{ total }})',
    successes:
      '{{ successesCount }} out of {{ total }} products have been successfully imported.',
    warning: '{{ count }} product was not fully imported.',
    warning_other: '{{ count }} products were not fully imported.',
    error: '{{ count }} product was not imported.',
    error_other: '{{ count }} products were not imported.',
    messages: {
      unknownIdentifier: 'Product SKU "{{ productCode }}" does not exist.',
      lowStock:
        'Quantity for {{ productName }}: {{ quantity }} has been reduced to {{ quantityAdded }}.',
      noStock: '{{ productName }} is currently out of stock.',
      unknownError: 'Unrecognized problem with "{{ productCode }}".',
      limitExceeded: 'Cannot add "{{ productCode }}". Limit exceeded.',
    },
    show: 'Show',
    hide: 'Hide',
  },
};

export const importExport = {
  exportEntries,
  importEntries,
  importEntriesDialog,
};
